import { TextCell } from "@silevis/reactgrid";
import { toast } from "components/FluentToast";
import { ICellTypeHandler } from "components/grecoreactgrid/ICellTypeHandler";
import { SelectAllCellTemplate } from "pages/BankStatements/BankStatementsGrid/customcells/SelectAllCellTemplate";

class SelectAllCellTypeHandler implements ICellTypeHandler {
  cellType = "selectall";
  isCustom = true;
  instance = new SelectAllCellTemplate();
  determineNewValue = (change: any) => {
    return (change.newCell as TextCell).text;
  };
  getEntryRow = (
    entry: any,
    columnConfig: any,
    rowsMetadataMap: any,
    keyColumn: string,
    context: {
      [key: string]: any;
    }
  ) => {
    const [
      { reminderEntriesSelectAll, reminderEntryMetadataMap },
      { setRemindersStoreValues },
    ] = context["remindersStore"];
    const { t } = context;

    return {
      type: "selectall",
      value: reminderEntriesSelectAll,
      checked: reminderEntriesSelectAll,
      hasVisible: [
        ...new Map(Object.entries(reminderEntryMetadataMap)).values(),
      ].reduce((acc: boolean, curr: any) => acc || curr.visible, false),
      onChecked: (checked: boolean) => {
        if (
          [
            ...new Map(Object.entries(reminderEntryMetadataMap)).values(),
          ].reduce((acc: boolean, curr: any) => acc || curr.inEditMode, false)
        ) {
          toast.error(
            t(
              "pct.please_save_or_cancel_your_changes_before_selecting_a_row.label"
            )
          );
        } else {
          let metadataMapCopy = { ...rowsMetadataMap };
          for (let item in metadataMapCopy) {
            metadataMapCopy[item].selected = checked;
          }

          setRemindersStoreValues({
            reminderEntriesSelectAll: checked,
            reminderEntryMetadataMap: metadataMapCopy,
          });
        }
      },
    };
  };
}

export default SelectAllCellTypeHandler;
